import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";
import { LayoutDashboard, Plane, ShoppingBag, Package, Wallet } from "lucide-react";

export default function BottomNav() {
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useI18n();
  const isActive = (path) => location.pathname.startsWith(path);
  const activeMode = user?.active_mode || user?.role || "buyer";
  const isJastiper = activeMode === "jastiper";

  // Iter 16+23: role-based nav.
  //  - Buyer mode → Home + Trips + Requests
  //  - Jastiper mode → Home + Catalog + Finance (Trips & Requests are buyer-flow buttons; hidden here)
  const items = isJastiper
    ? [
        { to: "/dashboard", icon: LayoutDashboard, label: t("bnav.home"), testid: "bottom-nav-dashboard" },
        { to: "/catalog", icon: Package, label: t("bnav.catalog"), testid: "bottom-nav-catalog" },
        { to: "/finance", icon: Wallet, label: "Finance", testid: "bottom-nav-finance" },
      ]
    : [
        { to: "/dashboard", icon: LayoutDashboard, label: t("bnav.home"), testid: "bottom-nav-dashboard" },
        { to: "/trips", icon: Plane, label: t("bnav.trips"), testid: "bottom-nav-trips" },
        { to: "/requests", icon: ShoppingBag, label: t("bnav.requests"), testid: "bottom-nav-requests" },
      ];

  const gridClass = items.length === 2 ? "grid-cols-2" : items.length === 3 ? "grid-cols-3" : "grid-cols-4";

  return (
    <nav
      className={`md:hidden fixed bottom-0 left-0 right-0 z-50 border-t grid ${gridClass}`}
      style={{
        paddingBottom: "env(safe-area-inset-bottom)",
        backgroundColor: "var(--app-surface)",
        borderColor: "var(--app-border)",
      }}
      data-testid="mobile-bottom-nav"
    >
      {items.map(({ to, icon: Icon, label, testid }) => {
        const active = isActive(to);
        return (
          <Link
            key={to}
            to={to}
            className="flex flex-col items-center justify-center py-2 gap-1 transition-colors"
            style={{ color: active ? "var(--app-brand)" : "var(--app-muted)" }}
            data-testid={testid}
          >
            <Icon size={20} strokeWidth={active ? 2 : 1.5} />
            <span className={`text-[10px] tracking-wide uppercase ${active ? "font-semibold" : "font-medium"}`}>{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
